// src/reducers/exampleReducer.js

import {
  FETCH_BASIC_CONFIG_DATA,
  FETCH_BASIC_CONFIG_SUCCESS,
  FETCH_BASIC_CONFIG_FAILURE,
  CHANGE_THEME,
  SET_USER_DETAILS_SUCCESS,
  GET_MESSAGE_LIBRARY_SUCCESS,
  GET_MESSAGE_LIBRARY_FAILURE,
  RESET_STATE,
  CLEAR_CACHE,
  SET_CONSOLE_DATA,
  SET_UTS,
  SET_MICRO_SERVICE_FLAG,
} from "../../../constants/action";

const initialState = {
  theme: "white",
  sidebarMenu: [],
  masterList: [],
  messageLibrary: [],
  userdetails: null,
  loading: false,
  error: null,
  console: null,
  isMicroServices: false,
};
const basicConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BASIC_CONFIG_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BASIC_CONFIG_SUCCESS:
      return {
        ...state,
        ...(action.payload.sidebarMenu
          ? { sidebarMenu: action.payload.sidebarMenu }
          : {}),
        ...(action.payload.masterList
          ? { masterList: action.payload.masterList }
          : { ...action.payload }),

        loading: false,
        error: null,
      };
    case FETCH_BASIC_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CHANGE_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case SET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userdetails: action.payload,
      };
    case GET_MESSAGE_LIBRARY_SUCCESS:
      return {
        ...state,
        messageLibrary: action.payload,
      };
    case GET_MESSAGE_LIBRARY_FAILURE:
      return {
        ...state,
        messageLibrary: action.payload,
      };
    case RESET_STATE:
      return {
        ...initialState,
      };
    case CLEAR_CACHE:
      return {
        ...state,
        theme: "white",
        sidebarMenu: [],
        masterList: [],
        messageLibrary: [],
        loading: false,
        error: null,
      };
    case SET_CONSOLE_DATA:
      return {
        ...state,
        console: action.payload,
      };
    case SET_UTS:
      return {
        ...state,
        console: {
          ...state.console,
          uts: action.payload,
        },
      };
    case SET_MICRO_SERVICE_FLAG:
      return { ...state, isMicroServices: action.payload };
    // Add other action cases as needed
    default:
      return state;
  }
};

export default basicConfigReducer;
